export function occupancyLevel(count, capacity) {
    // L'uguaglianza con la capienza si verifica prima delle percentuali: e' l'unico
    // modo perche' 1 su 1 sia pieno invece che "quasi".
    if (count > capacity)
        return "over";
    if (capacity <= 0 || count >= capacity)
        return "full";
    const ratio = count / capacity;
    if (ratio >= 0.8)
        return "near";
    if (ratio >= 0.5)
        return "filling";
    return "free";
}
/** Un solo vocabolario: il coach e l'atleta leggono le stesse parole. */
export const occupancyLabels = {
    free: "Libero",
    filling: "Si sta riempiendo",
    near: "Quasi pieno",
    full: "Pieno",
    over: "Oltre soglia",
};
/**
 * Il livello da solo copre situazioni che decidono in modo opposto: "quasi
 * pieno" e' 8 su 10 o 1 su 1? I numeri vanno sempre con la parola.
 */
export function occupancyCount(count, capacity) {
    return `${count}/${capacity}`;
}
